import _ from 'underscore'
import Types from '../../../actions/Types'

/*
const devUser = {
  id: 1,
  name: "Jason Racine",
  username: "jason.racine",
  authorizations: {
    login: true,
    inventory: true,
    maintenance: true,
    manage: true,
    admin: true
  },
  owners: [
    { id: 16, name: 'Anti-chutes' },
    { id: 11, name: 'Etat-Major' },
    { id: 12, name: 'Matériel' },
    { id: 14, name: 'Protection Respiratoire' }
  ],
  apikey: 'abcdefghijklmnopqrstuvwxyz'
}
*/

const initialState = {
  isFetching: false,
  user: null,
  error: null
}

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.AUTH.LOGIN.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        user: null,
        error: null
      })
    case Types.AUTH.LOGIN.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        user: action.data,
        error: null
      })
    case Types.AUTH.LOGIN.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        user: null,
        error: action.error
      })
    case Types.AUTH.LOGOUT.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        error: null
      })
    case Types.AUTH.LOGOUT.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        user: null,
        error: null
      })
    case Types.AUTH.LOGOUT.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === Types.AUTH
        ||
        action.api === Types.AUTH.LOGIN
        ||
        action.api === Types.AUTH.LOGOUT
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/app/identity.js